module.exports = __webpack_public_path__ + "static/img/down.6ad8026c.svg";